import React, { useEffect, useState } from 'react';
import { Switch } from 'antd';
import Card from '../Card';
import client from '../../../../api/graphql/client';
import { SET_USER_NOTIFICATION_PREFERENCE } from '../../../admin/mutations';
import { NOTIFICATION_PREFERENCES } from '../../../admin/notificationPreferences';
import { showSuccess, showError } from '../../../common/notifications';

// Opt-out: only an explicit false shows as Off.
const buildInitialState = notifications =>
  NOTIFICATION_PREFERENCES.reduce((acc, pref) => {
    acc[pref.key] = notifications?.[pref.key] !== false;
    return acc;
  }, {});

const NotificationPreferences = ({ title, userId, notifications }) => {
  const [submittingKey, setSubmittingKey] = useState(null);
  const [checkedByKey, setCheckedByKey] = useState(() => buildInitialState(notifications));

  // Re-seed toggle state when the notifications prop changes (e.g. admin
  // navigates to a different user, or the user query refetches) so the switches
  // reflect the current user's stored preferences rather than the first render's.
  useEffect(() => {
    setCheckedByKey(buildInitialState(notifications));
  }, [notifications]);

  const handleChange = (key, enabled) => {
    const previousValue = checkedByKey[key];
    setCheckedByKey(prev => ({ ...prev, [key]: enabled }));
    setSubmittingKey(key);
    client
      .mutate({
        mutation: SET_USER_NOTIFICATION_PREFERENCE,
        variables: { userId, key, enabled },
      })
      .then(() => {
        setSubmittingKey(null);
        showSuccess({ message: 'Notification preference updated' });
      })
      .catch(err => {
        setCheckedByKey(prev => ({ ...prev, [key]: previousValue }));
        setSubmittingKey(null);
        showError({ message: err.message });
      });
  };

  return (
    <Card
      title={title}
      description="Control which automated emails this user receives."
      floating
      actionComponent={
        <div className="flex flex-col gap-2">
          {NOTIFICATION_PREFERENCES.map(pref => (
            <div key={pref.key} className="flex items-center justify-between">
              <span className="mr-4">{pref.label}</span>
              <Switch
                checkedChildren="On"
                unCheckedChildren="Off"
                disabled={submittingKey === pref.key}
                checked={checkedByKey[pref.key]}
                onChange={enabled => handleChange(pref.key, enabled)}
              />
            </div>
          ))}
        </div>
      }
    />
  );
};

export default NotificationPreferences;
